import { Routes } from "@angular/router";

export const SuppliersRoutes: Routes = [
	{
		path: "",
		loadComponent: () =>
			import("@/app/domains/resource/catalog/pages/main-supply/main-supply.page").then(
				(m) => m.MainSupplyPage
			),
	},
	{
		path: "resource-container",
		loadComponent: () =>
			import("@/app/domains/resource/catalog/pages/resource-container/resource-container.page").then(
				(m) => m.ResourceContainerPage
			),
	},
	{
		path: "resource-edit",
		loadComponent: () =>
			import("@/app/domains/resource/catalog/pages/resource-edit/resource-edit.page").then(
				(m) => m.ResourceEditPage
			),
	},
	{
		path: "inventory-edit",
		loadComponent: () =>
			import(
				'@/app/domains/erp/inventory/pages/inventory-edit/inventory-edit.page'
			).then((m) => m.InventoryEditPage),
	},
	{
		path: "material-list-edit",
		loadComponent: () =>
			import("../pages/material-list-edit/material-list-edit.page").then(
				(m) => m.MaterialListEditPage
			),
	},
	{
		path: "promotion-edit",
		loadComponent: () =>
			import("@/app/domains/marketplace/promotions/pages/promotion-edit/promotion-edit.page").then(
				(m) => m.PromotionEditPage
			),
	},
	{
		path: "**",
		redirectTo: "",
		pathMatch: "full",
	},
];
